(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/matchview-match.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/matchview-match.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.MatchViewMatch = Backbone.Marionette.View.extend({
    modelEvents: {
      change: 'render'
    },
    events: {
      'click .js-row-button-matchview': 'markItem',
      'touchstart .js-outcomes': 'touchStartBetButton'
    },
    swipeIndex: 0,
    currentMatch: 0,
    log: new svs.core.log.Logger('svs.tipset.views.MatchViewMatch'),

    template: function(data) {
      return svs.tipset.templates.matchviewmatch(data);
    },

    update: function(options) {
      if (options) {
        if (options.match) {
          this.options.match = options.match;
        }
        this.currentMatch = parseInt(this.options.match, 10);
        if (options.round) {
          this.options.round = options.round;
        }
      }
      this.render();
      this.updateMatchSwiper();
    },

    markItem: function(ev) {
      var item = $(ev.currentTarget),
        mark = item.data('mark'),
        btnBet = item.find('.btn-bet');

      btnBet.toggleClass('btn-bet-selected');
      btnBet[0].offsetHeight; 
      this.model.setButtonBet(item.data('mark'));

      var currentMark = _.findWhere(this.model.get('marks'), {
        boardData: mark
      });

      if (currentMark.isSet) {
        btnBet.addClass('btn-bet-selected');

        if (currentMark.isU) {
          if (btnBet.find('.btn-bet-label-system').length === 0) {
            btnBet
              .parents('.js-outcomes')
              .find('.btn-bet-label-system')
              .remove();
            btnBet.append($('<span class="btn-bet-label-system">U</span>'));
          } else {
            btnBet.find('.btn-bet-label-system').remove();
          }
        }
      } else {
        btnBet.removeClass('btn-bet-selected');
        btnBet.find('.btn-bet-label-system').remove();
      }
    },

    touchStartBetButton: function(ev) {
      var target = $(ev.currentTarget),
        minimumDeltaX = 5,
        startButton,
        startButtonRowButton,
        startButtonSelected = false,
        startButtonSet = false,
        startX = ev.touches[0].clientX,
        deltaX,
        onMove = function(e) {
          var touch = e.touches[0],
            clientX = touch.clientX,
            clientY = touch.clientY,
            rowButton,
            currentEl;

          deltaX = Math.abs(clientX - startX);

          if (deltaX > minimumDeltaX) {
            if (
              !startButtonSet &&
              startButtonRowButton &&
              target.has(startButtonRowButton).length > 0 &&
              !startButtonRowButton.hasClass('js-row-button-touch-set') &&
              startButtonRowButton
                .find('.btn-bet')
                .hasClass('btn-bet-selected') === startButtonSelected
            ) {
              startButtonSet = true;
              startButtonRowButton.addClass('js-row-button-touch-set').click();
            }

            currentEl = $(document.elementFromPoint(clientX, clientY));

            if (currentEl.hasClass('js-row-button-matchview')) {
              rowButton = currentEl;
            } else if (currentEl.hasClass('btn-bet')) {
              rowButton = currentEl.parent('.js-row-button-matchview');
            }

            if (
              rowButton &&
              target.has(rowButton).length > 0 &&
              !rowButton.hasClass('js-row-button-touch-set') &&
              rowButton.find('.btn-bet').hasClass('btn-bet-selected') ===
                startButtonSelected
            ) {
              rowButton.addClass('js-row-button-touch-set').click();
            }
          }

          e.preventDefault();
        },
        onEnd = function(e) {
          target
            .find('.js-row-button-matchview')
            .removeClass('js-row-button-touch-set');
          target.off('touchmove', onMove);
          target.off('touchend', onEnd);

          if (deltaX > minimumDeltaX) {
            e.preventDefault();
            e.stopPropagation();
          }
        };

      if ($(ev.target).hasClass('js-row-button-matchview')) {
        startButton = $(ev.target).find('.btn-bet');
      } else if ($(ev.target).hasClass('btn-bet')) {
        startButton = $(ev.target);
      }

      startButtonRowButton = startButton.parent('.js-row-button-matchview');

      if (startButton && startButton.hasClass('btn-bet-selected')) {
        startButtonSelected = true;
      }

      target.on('touchmove', onMove);
      target.on('touchend', onEnd);
    },

    onClose: function() {
      if (this.slider) {
        this.slider.destroy();
      }

      this.undelegateEvents();
      this.stopListening();
    },

    onDestroy: function() {
      this.onClose();
    }
  });
})(Backbone, _, svs);

 })(window);